import { WorkTimeFractionModel } from 'app/models/contractModel'

export const getWorkTimeName = (
  workTime: WorkTimeFractionModel,
  translate: (string) => string,
): string => {
  if (
    workTime == null ||
    workTime.numeratorPart <= 0 ||
    workTime.denominatorPart <= 0
  ) {
    return '-'
  }

  if (workTime.numeratorPart === workTime.denominatorPart) {
    return translate('workTime.entire')
  }

  return `${workTime.numeratorPart}/${workTime.denominatorPart}`
}
